import { render } from "./TemplateVnfSettings.vue?vue&type=template&id=67ebe544&scoped=true"
import script from "./TemplateVnfSettings.vue?vue&type=script&lang=js"
export * from "./TemplateVnfSettings.vue?vue&type=script&lang=js"

import "./TemplateVnfSettings.vue?vue&type=style&index=0&id=67ebe544&lang=less&scoped=true"

import exportComponent from "/home/runner/work/cloudstack/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67ebe544"]])

export default __exports__